// Select all containers
const containers = document.querySelectorAll('.bee-container');

containers.forEach(container => {
  const trailAnim = container.querySelector('animate');
  const beeMotion = container.querySelector('animateMotion');

  if (!trailAnim || !beeMotion) return; // skip if missing

  // Observe data-state changes on this container
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.attributeName === 'data-state' && container.dataset.state === 'active') {
        // Get animation delay
        let delay = container.getAttribute('data-delay') ?? 0;
        // Set begin time dynamically
        trailAnim.setAttribute('begin', delay);
        beeMotion.setAttribute('begin', delay);

        // Trigger animations
        trailAnim.beginElement();
        beeMotion.beginElement();
      }
    });
  });

  observer.observe(container, { attributes: true });
});
